import React, { FunctionComponent } from "react";
import { useTheme } from "@mui/material";
import { Theme } from "@emotion/react";

export const TextLabelSvgComponent: FunctionComponent = () => {
    const theme = useTheme<Theme>();
    return (
        <svg height="100%" width="100%" viewBox="0 0 150 100">
            <polygon fill={theme.shades.one} points="30 20, 70 20, 75 70, 20 55" />
        </svg>
    );
};
